import Footer from "../../components/Footer";
import TopHeader from "../../components/TopHeader";

const Pl = () => {
  return (
    <>
      <TopHeader btn={true} />
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">Politique de confidentialité</h2>

          <p className="body mt-14 grey66 bold500">
            <p>Dernière mise à jour : 16/06/2025</p>
          </p>
          <p className="body grey66">
            Eppox SAS, nom commercial Twyny (« Twyny »), dont le siège social
            est établi au 78, Av. des Champs-Elysées, Bureau 326, 75008 Paris,
            France, s’engage à protéger la vie privée de ses utilisateurs,
            conformément au Règlement (UE) 2016/679 relatif à la protection des
            données à caractère personnel.
          </p>

          <p className="body grey66 mt-40">
            La présente politique de confidentialité vous informe notamment sur
            les types de données à caractère personnel que nous collectons vous
            concernant, ainsi que sur l’objectif de cette collecte et les
            modalités d’utilisation par nos services des données collectées.
            Twyny est soucieuse de l’enjeu qui existe autour de la protection
            des données de ses utilisateurs ou de tout utilisateur des services
            qu’elle offre. Aussi, Twyny traite les données à caractère personnel
            dont elle dispose dans le respect des législations relatives à la
            protection des données.
          </p>
          <p className="body grey66 mt-40">
            Twyny collecte les données que vous lui soumettez, conformément aux
            finalités définies en amont. Seules les données strictement
            nécessaires pour un usage préalablement défini sont recueillies.
          </p>
          <p className="body grey66 mt-40">
            Les traitements mis en œuvre sur son site web ont pour finalité :
          </p>
          <ul>
            <li className="body grey66 mb-10 mt-13">
              La gestion de formulaires de contact
            </li>
            <li className="body grey66 mb-10 mt-13">
              La gestion des réservations
            </li>
            <li className="body grey66 mb-10 mt-13">
              La gestion de l’accès à la newsletter
            </li>
            <li className="body grey66 mb-10 mt-13">
              La mise en œuvre de cookies utilisés pour tracer les activités de
              navigation
            </li>
            <li className="body grey66 mb-10 mt-13">
              L’information et la communication sur la société
            </li>
          </ul>
          <p className="body grey66 mt-40">
            Pour connaître notre politique en matière d’utilisation des cookies
            y compris les cookies utilisés, veuillez consulter la rubrique « Nos
            cookies » disponible sur ce site. Il vous sera également possible de
            paramétrer directement vos choix en matière d’utilisation de
            cookies.
          </p>
          <p className="body grey66 mt-40">
            La présente politique de confidentialité a pour vocation de vous
            apporter les réponses aux questions suivantes :
          </p>
          <ol>
            <h4 className="grey500 mt-40 mb-16">
              <li>
                Quelles sont les données collectées dans le cadre de l’activité
                du site web <a href="/">www.twyny.com</a> ?
              </li>
            </h4>
            <p className="body grey66">
              En tout état de cause, lors de la navigation sur le site web de
              Twyny, peuvent être recueillies : l’URL des liens par
              l’intermédiaire desquels l’utilisateur a accédé
              au site www.twyny.com, l’adresse de protocole Internet (IP) de
              l’utilisateur, le navigateur utilisé par l’utilisateur, le support
              utilisé par l’utilisateur (mobile, desktop, tablette).
            </p>
            <p className="body grey66">
              De manière générale, lors d’une réservation, demande de
              réservation, Twyny est susceptible de collecter auprès de vous,
              vos : nom, prénom, adresse de courrier électronique, numéro de
              téléphone, âge, ainsi que, auprès des participants aux services
              réservés, des informations spécifiques liées à l’organisation des
              services réservés.
            </p>

            <h4 className="grey500 mt-40 mb-16">
              <li>Comment disposons-nous de vos données personnelles ?</li>
            </h4>
            <p className="body grey66">
              Nous utilisons vos données à des fins exclusivement
              professionnelles et notamment pour faciliter l’utilisation du site
              et des services associés, interagir avec les utilisateurs et
              afficher de l’information à destination du public utilisateur de
              nos services. Nous collectons également vos données afin
              d’organiser les services réservés avec les Prestataires
              partenaires de Twyny, fournir nos services auprès de nos
              utilisateurs. De plus, grâce à la newsletter disponible, nous
              adressons à nos abonnés, des actualités sur notre activité ainsi
              que sur les différents événements dans lesquels nous sommes
              impliqués.
            </p>

            <h4 className="grey500 mt-40 mb-16">
              <li>
                A qui transmettons-nous les données que vous nous confiez ?
              </li>
            </h4>
            <p className="body grey66">
              Afin d’assurer au mieux notre mission, nous transmettons certaines
              données à divers destinataires :
            </p>

            <h3 className="mt-13 mb-16">En interne</h3>
            <p className="body grey66">
              Vos données sont confiées aux services compétents de Twyny.
            </p>

            <h3 className="mt-13 mb-16">En Externe</h3>
            <p className="body grey66">
              Vos données sont confiées aux Prestataires partenaires de Twyny.
            </p>

            <h3 className="mt-40 mb-16">
              Prestataires de services et autres tiers
            </h3>
            <p className="body grey66">
              Lorsque nous faisons appel à d’autres prestataires de services ou
              à d’autres tiers pour exécuter certaines parties de nos activités
              ou services, nous pouvons potentiellement être amenés à leur
              fournir des données strictement nécessaires à l’exécution de
              certaines tâches. Il peut s’agir notamment de :
            </p>

            <ul>
              <li className="body grey66 mb-10 mt-13">
                Développer des outils sur notre site Web ;
              </li>
              <li className="body grey66 mb-10 mt-13">
                Héberger des données sur le cloud ;
              </li>
              <li className="body grey66 mb-10 mt-13">Marketing</li>
              <li className="body grey66 mb-10 mt-13">Statistiques ;</li>
              <li className="body grey66 mb-10 mt-13">Réseaux sociaux ;</li>
              <li className="body grey66 mb-10 mt-13">
                Communications (envoi d’emails et de SMS liés à votre
                réservation).
              </li>
            </ul>

            <h4 className="grey500 mt-40 mb-16">
              <li>Comment démontrons-nous le respect de vos droits ?</li>
            </h4>
            <p className="body grey66">
              L’utilisation de vos données à caractère personnel par Twyny vous
              permet de bénéficier de certains droits. Ces droits sont
              directement prévus par le RGPD.
            </p>
            <p className="body grey66">Vous disposez des droits suivants :</p>
          </ol>
          <h4 className="grey500 mt-40 mb-16">
            5.1 Droit à l’information (articles 12, 13, 14 RGPD)
          </h4>
          <p className="body grey66">
            Vous pouvez avoir connaissance des données à caractère personnel que
            Twyny traite à votre sujet. Pour ce faire, nous mettons à
            disposition des utilisateurs de nos services, une information
            conforme aux exigences réglementaires, lorsque nous collectons leurs
            données à caractère personnel, sur nos documents utilisés pour la
            collecte des données.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            5.2 Droit de rectification (article 16 RGPD)
          </h4>
          <p className="body grey66">
            Si vos données à caractère personnel sont inexactes, vous pouvez
            nous demander de les rectifier. De même, si nous les avons
            transmises à un tiers, nous transmettrons également à ce tiers la
            rectification demandée.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            5.3 Droit d’opposition (article 21 RGPD)
          </h4>
          <p className="body grey66">
            Vous pouvez dans certains cas, vous opposer à l’utilisation de vos
            données à caractère personnel. Nous prenons en compte votre demande
            d’opposition et déterminons si le traitement de vos données
            personnelles vous porte injustement préjudice et que ce préjudice
            nous force à y mettre fin.
          </p>
          <p className="body grey66">
            D’une manière générale, vous ne pouvez pas vous opposer au
            traitement de vos données à caractère personnel si :
          </p>

          <ul>
            <li className="body grey66 mb-10 mt-13">
              Nous avons une obligation légale de l’effectuer
            </li>
            <li className="body grey66 mb-10 mt-13">
              Il est nécessaire à l’exécution d’un contrat qui vous lie à Twyny
            </li>
            <li className="body grey66 mb-10 mt-13">
              Il est nécessaire à la bonne exécution des services réservés sur
              Twyny par les Prestataires Partenaires
            </li>
          </ul>
          <h4 className="grey500 mt-40 mb-16">
            5.4 Droit à la limitation du traitement (article 18 RGPD)
          </h4>
          <p className="body grey66">
            Vous pouvez nous saisir afin d’obtenir la limitation de notre
            utilisation de vos données à caractère personnel si :
          </p>
          <ul>
            <li className="body grey66 mb-10 mt-13">
              Vous pensez que vos données à caractère personnel sont inexactes ;
            </li>
            <li className="body grey66 mb-10 mt-13">
              Nous traitons vos données de manière inexacte
            </li>
            <li className="body grey66 mb-10 mt-13">
              Nous ne sommes plus fondés à conserver ces données mais, vous
              souhaitez que nous les conservions pour qu’elles soient utilisées
              à d’autres fins
            </li>
            <li className="body grey66 mb-10 mt-13">
              Vous vous êtes opposé à notre utilisation de vos données basée sur
              nos intérêts légitimes.
            </li>
          </ul>
          <h4 className="grey500 mt-40 mb-16">
            5.5 Droit à la portabilité (article 20 RGPD)
          </h4>
          <p className="body grey66">
            Vous pouvez nous demander le transfert de vos données à caractère
            personnel, soit à vous à titre personnel, soit à un organisme.
          </p>
          <h4 className="grey500 mt-40 mb-16">
            5.6 Droit à l’oubli (article 17 RGPD)
          </h4>
          <p className="body grey66">
            Dans le cadre de l’utilisation des données à caractère personnel que
            vous nous confiez, nous sommes tenus de les conserver pendant une
            durée déterminée, afin de se conformer aux lois et réglementations
            applicables. Toutefois, ce droit ne peut être valablement mis en
            œuvre qu’à l’expiration des durées légales et/ou réglementaires
            applicables. Dans le cas où une durée légale ou réglementaire n’est
            pas applicable, le droit à l’oubli pourra être exercé si vous
            retirez votre consentement donné.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            6. Quels traitements donnent lieu à des décisions automatisées ?
          </h4>
          <p className="body grey66">
            Twyny n’effectue pas de traitement automatisé de données à caractère
            personnel.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            7. Comment sécurisons-nous les données que vous nous confiez ?
          </h4>
          <p className="body grey66">
            Nous mettons en œuvre des mesures techniques et organisationnelles
            (politiques, procédures, sécurité physique de nos locaux, sécurité
            logique de nos systèmes d’information). Ces mesures visent à
            garantir la confidentialité, la disponibilité et l’intégrité des
            données.
          </p>
          <p className="body grey66">
            De plus, les employés de Twyny sont soumis à une obligation de
            confidentialité.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            8. Combien de temps conservons-nous vos données ?
          </h4>
          <p className="body grey66">
            La réglementation en vigueur relative à la protection des données à
            caractère personnel nous impose de conserver les données à caractère
            personnel pendant une durée définie et limitée. Lorsque nous
            identifions que les données dont nous disposons vous concernant ne
            sont plus nécessaires, pour les fins liées à leur collecte, nous les
            supprimons ou, nous assurons leur anonymisation.
          </p>
          <p className="body grey66">
            Les données de nos utilisateurs sont conservées pendant le temps de
            la relation commerciale. Elles peuvent être conservées à des fins de
            prospection commerciale au maximum pendant 3 ans à compter de la fin
            de cette relation commerciale.
          </p>
          <p className="body grey66">
            Les informations stockées dans le terminal des utilisateurs (exemple
            : cookies) ou tout autre élément utilisé pour identifier les
            utilisateurs et permettant de tracer des utilisateurs sont
            conservées pour une durée n’excédant pas 6 mois.
          </p>
          <p className="body grey66">
            Les données utilisées dans le cadre de la diffusion des newsletters
            sont conservées jusqu’au désabonnement de l’utilisateur.
          </p>
          <p className="body grey66">
            Nous demandons tous les 13 mois le consentement des visiteurs de
            notre site web pour le traitement des cookies.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            9. Comment et où pouvez-vous exercer vos droits ?
          </h4>
          <p className="body grey66">
            Si vous souhaitez exercer vos droits, vous pouvez adresser une
            demande écrite au Délégué à la Protection des données (DPO) à
            l’adresse courriel suivante : {" "}
            <a href="mailto:support@twyny.com">support@twyny.com.</a>
          </p>
          <p className="body grey66">
            Vous pouvez nous adresser votre demande de la façon la plus précise.
            Idéalement, il conviendra de nous adresser une copie de votre pièce
            d’identité, afin de confirmer votre identité. Si votre demande est
            conforme, nous vous adresserons une réponse dans le délai d’un mois.
            En cas de refus, une réponse motivée vous sera adressée dans les
            meilleurs délais.
          </p>

          <h4 className="grey500 mt-40 mb-16">
            10. Droit d’introduire une réclamation
          </h4>
          <p className="body grey66">
            Advenant une réclamation non satisfaite de notre part, vous pouvez
            nous adresser directement une plainte. Dans l’hypothèse où notre
            réponse ne vous convient pas, vous pouvez contacter la Commission
            Nationale Informatique et Libertés (CNIL) - 3 place de Fontenoy -
            TSA 80715 - 75334 PARIS CEDEX 07 — www.cnil.fr.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Pl;
